import { render } from "./WarningMessage.vue?vue&type=template&id=37ac3dae&scoped=true"
import script from "./WarningMessage.vue?vue&type=script&lang=js"
export * from "./WarningMessage.vue?vue&type=script&lang=js"

import "./WarningMessage.vue?vue&type=style&index=0&id=37ac3dae&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37ac3dae"]])

export default __exports__